import React, { useCallback } from "react";
import { Modal } from "storybook/components/modal";
import { Typography } from "storybook/components/typography";
import { Button } from "storybook/components/button";
import toast from "storybook/components/toast";
import { usePreferredLanguage } from "context/preferred-language";
import { useTransifexLoader } from "context/transifex-loader";
import { SPECIALIST_HOSTNAME } from "env-vars";
import { ContentWrapper } from "./styles";

export const LanguagePrompt = () => {
  const { showLanguagePrompt, setShowLanguagePrompt, setPreferredLanguage } =
    usePreferredLanguage();
  const { lang } = useTransifexLoader();

  const canShowLanguagePrompt =
    localStorage.getItem("ciq_can_show_language_prompt") === "true";

  const handleClose = useCallback(() => {
    setShowLanguagePrompt(false);
    localStorage.removeItem("ciq_can_show_language_prompt");
  }, [setShowLanguagePrompt]);

  const handleUpdate = useCallback(async () => {
    const patientId = localStorage.getItem("ciq_id");
    const idToken = localStorage.getItem("id_token");

    try {
      const response = await fetch(
        `${SPECIALIST_HOSTNAME}/api/v1/people/${patientId}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${idToken}`,
          },
          body: JSON.stringify({
            preferred_language: lang,
          }),
        }
      );

      if (response.ok) {
        setPreferredLanguage(lang as string);
        toast.success("Preferred language updated successfully");
        handleClose();
      }
    } catch (error) {
      console.error("Error saving preferred language:", error);
      toast.error("Error saving preferred language");
    }
  }, [handleClose, setPreferredLanguage, lang]);

  return (
    <Modal
      open={showLanguagePrompt && canShowLanguagePrompt}
      onClose={handleClose}
      theme="default"
      disableBackdropClick={true}
      hideCloseButton={true}
    >
      <Modal.Head alignTitle="left">Language Preference</Modal.Head>
      <Modal.Body>
        <ContentWrapper>
          <Typography theme="default" variant="body1" color="black">
            We noticed you've selected a different language than what's saved in
            your profile. Would you like to update your profile to match your
            current language selection?
          </Typography>
        </ContentWrapper>
      </Modal.Body>
      <Modal.Actions>
        <Button
          theme="default"
          variant="text"
          color="default"
          onClick={handleClose}
        >
          Cancel
        </Button>
        <Button
          theme="default"
          variant="contained"
          color="default"
          onClick={handleUpdate}
        >
          Update
        </Button>
      </Modal.Actions>
    </Modal>
  );
};
